


if (document.documentMode && document.documentMode <= 11) {
    // "new CustomEvent()" is broken in IE, apparently. However, this polyfill/hack works.
    // See http://stackoverflow.com/a/26596324
    (function () {
        function CustomEvent ( event, params ) {
            params = params || { bubbles: false, cancelable: false, detail: undefined };
            let evt = document.createEvent( 'CustomEvent' );
            evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
            return evt;
        }

        CustomEvent.prototype = window.Event.prototype;

        window.CustomEvent = CustomEvent;
    })();
}


/**
 * Dispatch a custom event on the given HTML element
 *
 * @param {HTMLElement} element
 * @param {string} eventName
 * @param {object} [eventData]
 */
export default (element, eventName, eventData = {}) => {

    let event;

    if (window.CustomEvent) {
        event = new CustomEvent(eventName, { detail: eventData, bubbles: true, cancelable: true });
    } else {
        event = document.createEvent('CustomEvent');
        event.initCustomEvent(eventName, true, true, eventData);
    }

    element.dispatchEvent(event);

};